<cdk-accordion>
  <cdk-accordion-item #item="cdkAccordionItem" [expanded]="true">
    <div
      class="group h-8 pl-4 pr-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer transition-colors"
    >
      <div
        class="flex flex-auto items-center gap-1 min-w-0"
        (click)="item.toggle()"
        role="presentation"
      >
        <span class="flex-auto truncate text-sm font-medium">Legenda</span>
        <mat-icon
          class="flex-none"
          [class]="item.expanded ? 'rotate-0' : 'rotate-180'"
          >keyboard_arrow_up</mat-icon
        >
      </div>
    </div>

    @if (item.expanded) {
      <div class="text-sm overflow-hidden space-y-2 py-2">
        @for (item of legendItems; track $index) {
          <div
            class="legend-item pl-4 pr-2 flex items-center gap-2"
            [matTooltip]="item.label"
            [class]="item.classes"
          >
            <div
              class="size-4 flex-none rounded-full border-2 border-(--event-border-color) bg-(--event-bg-color) p-0.5"
            ></div>

            <span class="flex-auto truncate">{{ item.label }}</span>
          </div>
        }
      </div>
    }
  </cdk-accordion-item>
</cdk-accordion>
